import React from "react";
import styled, { css } from "styled-components";
import { typography } from "screens/Homepage/components/typography";
import { LinkMarketingButton } from "screens/Homepage/styles";
import RiveWrapper from "components/RiveAnimation";

interface IProps {
  title: string;
  description: string;
  docsUrl?: string;
  artboard?: string;
}

const RIVE_FILE_PATH = "/beam.riv";
const STATE_MACHINE_NAME = "State Machine 1";

const FeatureCard: React.FC<IProps> = ({ title, description, docsUrl, artboard }) => {
  return (
    <Container>
      {artboard ? (
        <ImageContainer>
          <RiveWrapper stateMachine={STATE_MACHINE_NAME} artboard={artboard} riveFilePath={RIVE_FILE_PATH} />
        </ImageContainer>
      ) : null}
      <TextContentContainer>
        <Title>{title}</Title>
        <Description>{description}</Description>
        {docsUrl && (
          <LinkMarketingButton
            href={docsUrl}
            icon="far-arrow-up-right"
            buttonTheme="secondary"
            variant="outline"
          >
            Explore Docs
          </LinkMarketingButton>
        )}
      </TextContentContainer>
    </Container>
  );
};

export default FeatureCard;

const Container = styled.div`
  ${({ theme }) => {
    return css`
      display: flex;
      flex-direction: column;
      padding: 0px;
      width: 100%;
      max-width: 564px;
      height: fit-content;
      background: ${theme.colors.gray2};
      border: 1px solid ${theme.colors.gray6};
      border-radius: 8px;
    `;
  }}
`;

const ImageContainer = styled.div`
  width: 100%;
  aspect-ratio: 16/9;
  overflow: hidden;
  border-radius: 8px 8px 0 0;
`;

const TextContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  gap: 8px;
  width: 100%;
`;

const Title = styled.h5`
  ${({ theme }) => {
    return css`
      all: unset;
      color: ${theme.colors.gray12};
      ${typography.title20};
    `;
  }}
`;

const Description = styled.p`
  ${({ theme }) => {
    return css`
      all: unset;
      color: ${theme.colors.gray11};
      ${typography.textBaseLight};
      margin-bottom: 8px;
    `;
  }}
`;
